/* --------------------------------------------------------------------------------
 	*   scroll_go_to_top.METHOD({PARAMS});

	Scrollt von Page-Bottom zu Page-Top 
	
	Diese Params koennen ueberschrieben werden, falls sie vom Default abweichen.
	PARAMS: 
		{	
			debug: false,
			offset: 5, //1300,
			offset_opacity: $(document).outerHeight(), //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
			scroll_top_duration: 500, //duration of the top scrolling animation (in ms)
			back_to_top: '.cd-top' //grab the "back to top" link
		}

	METHODS:
	* init
		- Scrollt von Page-Bottom zu Page-Top 
		Bsp.:
			scroll_go_to_top.init({offset_opacity: $(document).outerHeight()});
	  	Return: ---
----------------------------------------------------------------------------------- */
var scroll_go_to_top = (function() {
	"use strict"; // Preventing you from using undeclared variables. IE 9 will not throw an error even if it does not understand it.

	// --------------------------------------------------------------------------------
	//  *   Private Vars
	//  -------------------------------------------------------------------------------
	var params = {
		debug: false,
		offset: 5, //1300,
		offset_opacity: 0,// $(document).outerHeight() browser window scroll (in pixels) after which the "back to top" link opacity is reduced
		scroll_top_duration: 500, //duration of the top scrolling animation (in ms)
		back_to_top: '.cd-top' //grab the "back to top" link
	};

	var settings = $.extend({} ,params),
		debug = settings.debug;

	// --------------------------------------------------------------------------------
	//  *   Public Methods
	//  -------------------------------------------------------------------------------
	var init = function(params) {
		set_params(params);

		//hide or show the "back to top" link
		$(window).scroll(function(){

			( $(this).scrollTop() > settings.offset ) ? $(settings.back_to_top).addClass('cd-is-visible') : $(settings.back_to_top).removeClass('cd-is-visible cd-fade-out');
			if( $(this).scrollTop() > settings.offset_opacity ) { 
				$(settings.back_to_top).addClass('cd-fade-out');
			}
		});
		
		//smooth scroll to top
		$(settings.back_to_top).on('click', function(event){ 
			event.preventDefault();
			$('body,html').animate({
				scrollTop: 0 ,
			}, settings.scroll_top_duration );
		});
	};

	// --------------------------------------------------------------------------------
	//  *   Private Methods
	//  -------------------------------------------------------------------------------
	var set_params = function() {
		$.each(Array.prototype.slice.call(arguments), function(i, val) {
			if (typeof val == 'object' ) {
				settings = $.extend(params, val);
			}
			else {
				var key = 'param_'+i,
					obj = {};
					obj[val] = val;
					obj[key] = val;
				
				settings = $.extend(params, obj);
			}
		});
		debug = settings.debug;
	};

	// --------------------------------------------------------------------------------
	//  *   Public Methods API (Aufruf)
	//  -------------------------------------------------------------------------------
	return {
		init: init
	};

	/*
	
	var args = arguments,
			returnValue = null,
			params  = args[0];

		var offset = 5, //1300,
			//browser window scroll (in pixels) after which the "back to top" link opacity is reduced
			offset_opacity = $(document).outerHeight(),
			//duration of the top scrolling animation (in ms)
			scroll_top_duration = 500,
			//grab the "back to top" link
			$back_to_top = $('.cd-top');

		//hide or show the "back to top" link
		$(window).scroll(function(){
			( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
			if( $(this).scrollTop() > offset_opacity ) { 
				$back_to_top.addClass('cd-fade-out');
			}
		});
		
		//smooth scroll to top
		$back_to_top.on('click', function(event){ 
			event.preventDefault();
			$('body,html').animate({
				scrollTop: 0 ,
			}, scroll_top_duration );
		});
	
		return returnValue;
	}
	*/
})( jQuery );// ---------- * end: scroll_go_to_top * --------------------

$(document).ready(function(){
	// ========== * Scrollt von Page-Bottom to Top * ======================================================================
	scroll_go_to_top.init({offset_opacity:$(document).outerHeight()});
});